<template>
  <div class="ren-decoration-items">
    <div class="ren-decoration-field-group">
      <label>图片</label>
      <WidgetImageUpload :model-value="imageUrl" :disabled="readonly" @update:model-value="(url) => patch({ imageUrl: url })" />
    </div>
    <div class="ren-decoration-field-group">
      <label>图片地址</label>
      <RrInput
        :value="imageUrl"
        :disabled="readonly"
        placeholder="也可直接粘贴图片地址"
        @update:value="(val) => patch({ imageUrl: String(val ?? '') })"
      />
    </div>
    <div class="ren-decoration-field-group">
      <label>替代文本</label>
      <RrInput
        :value="altText"
        :disabled="readonly"
        placeholder="图片说明"
        @update:value="(val) => patch({ altText: String(val ?? '') })"
      />
    </div>
    <div class="ren-decoration-field-group">
      <label>填充方式</label>
      <RrSelect
        :value="fitMode"
        :disabled="readonly"
        :options="fitModeOptions"
        @update:value="(val) => patch({ fitMode: String(val ?? 'COVER') })"
      />
    </div>
    <div class="ren-decoration-field-group">
      <label>跳转目标</label>
      <RrInput
        :value="linkTarget"
        :disabled="readonly"
        placeholder="跳转目标"
        @update:value="(val) => patch({ linkTarget: String(val ?? '') })"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { RrInput, RrSelect } from '@xjlv2/ui'
import { mergeWidgetProps, type WidgetSettingsProps } from '../../types'
import WidgetImageUpload from '../../WidgetImageUpload.vue'

const props = withDefaults(defineProps<WidgetSettingsProps>(), {
  readonly: false
})

const emit = defineEmits<{
  'update:props': [props: Record<string, unknown>]
}>()

const fitModeOptions = [
  { label: '裁剪填充', value: 'COVER' },
  { label: '完整显示', value: 'CONTAIN' },
  { label: '拉伸填充', value: 'FILL' }
]

const imageUrl = computed(() => String(props.component.props?.imageUrl ?? ''))
const altText = computed(() => String(props.component.props?.altText ?? props.component.props?.alt ?? ''))
const fitMode = computed(() => {
  const value = String(props.component.props?.fitMode ?? 'COVER').toUpperCase()
  return ['COVER', 'CONTAIN', 'FILL'].includes(value) ? value : 'COVER'
})
const linkTarget = computed(() =>
  String(props.component.props?.linkTarget ?? props.component.props?.link ?? '')
)

function patch(partial: Record<string, unknown>) {
  emit('update:props', mergeWidgetProps(props.component, partial))
}
</script>
